import {createSvgIcon} from './utils'

export default createSvgIcon(
  <path
    clipRule="evenodd"
    d="M10 20C15.523 20 20 15.523 20 10C20 4.477 15.523 0 10 0C4.477 0 0 4.477 0 10C0 15.523 4.477 20 10 20ZM14.6595 6.25113C14.46 6.07681 14.1994 5.9888 13.935 6.00643C13.6707 6.02405 13.4241 6.14587 13.2495 6.34513L8.73249 11.8001L6.7365 9.32513C6.5549 9.14018 6.30857 9.03296 6.04946 9.02609C5.79035 9.01922 5.53869 9.11323 5.34754 9.2883C5.15639 9.46337 5.04069 9.70581 5.02483 9.96453C5.00896 10.2232 5.09417 10.478 5.2625 10.6751L7.6355 13.5001C7.90405 13.7936 8.27146 14.0337 8.73249 14.0337C9.256 14.0337 9.7876 13.7494 9.99949 13.5001C10.2114 13.2508 14.7535 7.66213 14.7535 7.66213C14.9279 7.46273 15.0161 7.20225 14.9987 6.93789C14.9812 6.67353 14.8586 6.4259 14.6595 6.25113Z"
    fill="#21201F"
    fillRule="evenodd"
  />,
  'CheckCircleFilled',
)
